export const Actions = {
    ABLE_TO_WITHDRAW_FETCH_INIT: 'WITHDRAW_ABLE_TO_WITHDRAW_FETCH_INIT',
    ABLE_TO_WITHDRAW_FETCH_SUCCESS: 'WITHDRAW_ABLE_TO_WITHDRAW_FETCH_SUCCESS',
    ABLE_TO_WITHDRAW_FETCH_ERROR: 'WITHDRAW_ABLE_TO_WITHDRAW_FETCH_ERROR',
    ABLE_TO_WITHDRAW_RESET: 'WITHDRAW_ABLE_TO_WITHDRAW_RESET',
    SET_WITHDRAW_VALUE: 'WITHDRAW_SET_WITHDRAW_VALUE',
    SET_BANK_ACCOUNT: 'WITHDRAW_SET_BANK_ACCOUNT',
};
